// Add this to your theme.js or a separate wishlist.js file
const handleWishlist = () => {
  // Select all wishlist buttons
  const wishlistButtons = document.querySelectorAll('.wishlist-button');

  wishlistButtons.forEach((button) => {
    button.addEventListener('click', async function (e) {
      e.preventDefault();

      if (!window.customer) {
        window.location.href = '/pages/wishlist';
        return;
      }

      const productId = this.dataset.productId;
      const productHandle = this.dataset.productHandle;

      this.disabled = true;
      this.classList.add('dn');
      
      const toast = document.createElement('div');
      toast.textContent = this.classList.contains('is-active')
        ? 'Product removed from wishlist'
        : 'Product added to wishlist';
      toast.className = 'toast';
      // this.insertAdjacentElement('afterend', toast);
      document.body.appendChild(toast);
      // Remove the span after 3 seconds
      setTimeout(() => {
        toast.remove();
        this.classList.remove('dn');
        this.disabled = false;
      }, 3000);

      this.classList.toggle('is-active');

      try {
        const response = await fetch('https://us-central1-suet-170506.cloudfunctions.net/wishlists', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            product_id: productId,
            product_handle: productHandle,
            user_id: window.customer.id,
          }),
        });

        if (response.ok) {
          // this.classList.toggle('is-active');
          // console.log('Added to wishlist!');
        } else {
          this.classList.toggle('is-active');
          throw new Error('Failed to add to wishlist');
        }
      } catch (error) {
        console.error('Error:', error);
        // Handle error - show error message to user
      }
    });
  });
};

// Initialize when DOM is loaded
document.addEventListener('DOMContentLoaded', () => {
  setTimeout(() => {
    handleWishlist();
  }, 1000);
});
